<template>
  <li class="address-search-li" @click="selectAddress" tabindex="0">
    <strong>{{ item.name }}</strong><br>
    <span>{{ this.type }}</span>
  </li>
</template>

<script>

export default {
  data() {
    return {
      type: '',
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    tagList: {
      type: Object,
      required: true
    }
  },
  created() {
    //console.log(this.item);
    if(this.item.type == 'item') {
      this.item.type, this.type = this.$props.tagList[parseInt(this.item.tagId)].name;
    }
    else if(this.item.type == 'coords') {
      this.type = 'Adresse fra historik';
    }
    else if(this.item.type == 'Vej') {
      if(this.item.coords != undefined) {
        this.type = 'Adresse fra historik';
      }
      else {
        this.type = this.item.code+', '+this.item.comune;
      }
    }
    else if(this.item.type == 'userAddress') {
      this.type = 'Favoritadresse';
    }
    else {
      this.type = this.item.type;
    }
  },
  methods: {
    selectAddress() {
      this.$emit('addressSelected', this.item);
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
